import { SET_USER_ID, SET_CURRENT_PORTAL, SET_PORTAL_TIME_ZONE, SET_USER_ROLE, SET_AVAILABLE_PORTALS, RESET_USER, SET_AVAILABLE_PLANS, SET_IS_CYBER_VIEWS_ENABLED, SET_IS_SME_LOGS_ENABLED } from '../actions/user.actions';

const initialState = {
    userId: null,
    userRole: null,
    currentPortal: null,
    portalTimeZone: null,
    availablePortals: null,
    isCyberViewsEnabled: null,
    isSMELogsEnabled: null
}

export default function userReducer(state = initialState, action) {
    switch(action.type) {
        case SET_USER_ID:
            return {...state, userId: action.payload.userId};
        case SET_USER_ROLE:
                return {...state, userRole: action.payload.userRole};
        case SET_CURRENT_PORTAL:
            return {...state, currentPortal: action.payload.currentPortal};
        case SET_PORTAL_TIME_ZONE:
            return {...state, portalTimeZone: action.payload.portalTimeZone};
        case SET_AVAILABLE_PORTALS:
            return {...state, availablePortals: action.payload.availablePortals};
        case SET_AVAILABLE_PLANS:
            return {...state, availablePlans: action.payload.availablePlans};
        case SET_IS_CYBER_VIEWS_ENABLED:
            return {...state, isCyberViewsEnabled: action.payload.isCyberViewsEnabled};
        case SET_IS_SME_LOGS_ENABLED:
            return {...state, isSMELogsEnabled: action.payload.isSMELogsEnabled};
        case RESET_USER:
            return initialState;
        default:
            return state;
    }
}